import isMobileLib from 'is-mobile';

const useDevice = () => {
    const isMobileOrTablet = isMobileLib({ tablet: true, featureDetect: true });
    const isChromeOnIOS = navigator.userAgent.includes('CriOS');
    const isFirefoxOnIOS = navigator.userAgent.includes('FxiOS');
    const isOperaOnIOS = navigator.userAgent.includes('OPiOS');

    return {
        isMobileOrTablet,
        isChromeOnIOS,
        isFirefoxOnIOS,
        isOperaOnIOS
    }
}

export default useDevice;